import React, { useState } from "react";
import DeleteIcon from "@atlaskit/icon/core/delete";
import Button from "@atlaskit/button/new";
import ConfirmModal from "../../../common/components/ConfirmModal";
import { useDispatch } from "react-redux";
import { deleteFlow } from "../../../redux/actions/integrationActions";

const DeleteFlowMenuItem = ({ flow, onClickCallback }) => {
  const [isShowConfirmModal, setShowConfirmModal] = useState(false);
  const dispatch = useDispatch();

  const handleOnDeleteClick = () => {
    setShowConfirmModal(true);
    onClickCallback();
  };

  const doDeleteFlow = () => {
    setShowConfirmModal(false);
    dispatch(deleteFlow(flow));
  };

  return (
    <>
      <Button iconBefore={DeleteIcon} appearance="subtle" onClick={handleOnDeleteClick}>
        Delete flow
      </Button>
      <ConfirmModal
        action={"delete the entire integration flow"}
        targetName={flow ? flow.name : ""}
        targetId={flow ? flow.id : ""}
        isOpen={isShowConfirmModal}
        onAction={doDeleteFlow}
        onClose={() => setShowConfirmModal(false)}
      />
    </>
  );
};
export default DeleteFlowMenuItem;
